import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  controlContactInfos,
  selectMemberInfo,
} from "../../../state/ducks/member/index";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import EminevimLoading from "../shared/EminevimLoading";
import LoginPageAlert from "../Login/LoginPageAlert";

function validateEmail(email) {
  const value = (email || "").trim();

  if (!value) {
    return "Eposta alanı boş bırakılamaz.";
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return "Lütfen geçerli bir Eposta giriniz.";
  }

  return null;
}

class ControlContactInfo extends Component {
  state = {
    bilgi: "",
    iletisimTur: this.props.match?.params?.id,
    countryPhoneCode: "90",
    shouldAnimateCard: false,
    isProcessing: false,
    formAlert: null,
    emailHasError: false,
  };

  componentDidMount() {
    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match?.params?.id !== this.props.match?.params?.id) {
      this.setState({
        bilgi: "",
        iletisimTur: this.props.match?.params?.id,
        formAlert: null,
        emailHasError: false,
        countryPhoneCode: "90",
      });
    }

    if (this.props.member?.controlContact) {
      this.props.history.push(
        "/Home/UpdateContactInfo/" + this.props.match?.params?.id
      );
    }
  }

  clearFormAlert = () => {
    this.setState({ formAlert: null });
  };

  validatePhone = () => {
    const value = (this.state.bilgi || "").replace(/\D/g, "");

    if (!value) {
      return "Telefon alanı boş bırakılamaz.";
    }

    if (value.length < 10) {
      return "Lütfen geçerli bir telefon giriniz.";
    }

    return null;
  };

  submit = (event) => {
    event.preventDefault();
    const contactType = this.props.match?.params?.id || this.state.iletisimTur;
    const isEmail = contactType === "Eposta";

    const submitContact = (bilgi, countryPhoneCode) => {
      this.setState({ isProcessing: true, formAlert: null });
      Promise.resolve(
        this.props.controlContactInfo(bilgi, contactType, countryPhoneCode)
      )
        .then((result) => {
          if (result && result.success === false) {
            this.setState({
              formAlert: {
                type: "error",
                messages: [result.message],
              },
            });
          }
        })
        .finally(() => {
          this.setState({ isProcessing: false });
        });
    };

    if (isEmail) {
      const validationMessage = validateEmail(this.state.bilgi);

      if (validationMessage) {
        this.setState({
          emailHasError: true,
          formAlert: {
            type: "error",
            messages: [validationMessage],
          },
        });
        return;
      }

      submitContact(this.state.bilgi.trim());
      return;
    }

    const phoneValidationMessage = this.validatePhone();
    if (phoneValidationMessage) {
      this.setState({
        formAlert: {
          type: "error",
          messages: [phoneValidationMessage],
        },
      });
      return;
    }

    submitContact(this.state.bilgi.replace(/\D/g, ""), this.state.countryPhoneCode);
  };

  renderContactSteps = (firstStepLabel) => (
    <div className="t-controlContactInfo-steps">
      <div className="t-controlContactInfo-step t-controlContactInfo-step--active">
        <span className="t-controlContactInfo-stepNumber">1</span>
        <span className="t-controlContactInfo-stepLabel">{firstStepLabel}</span>
      </div>
      <div className="t-controlContactInfo-stepLine" aria-hidden="true" />
      <div className="t-controlContactInfo-step">
        <span className="t-controlContactInfo-stepNumber">2</span>
        <span className="t-controlContactInfo-stepLabel">Onay</span>
      </div>
    </div>
  );

  renderEmailSteps = () => this.renderContactSteps("Yeni Mail");

  renderContactHeader = (iconClass, title) => (
    <div className="t-memberInfo-cardHeader">
      <Link
        to="/Home/AccountInfo"
        className="t-memberDetail-headerBack"
        title="Profilime Dön"
        aria-label="Profilime Dön"
      >
        <i className="t-icon-arrow-left2" aria-hidden="true" />
      </Link>

      <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
        <i className={iconClass} aria-hidden="true" />
      </div>

      <div className="t-memberInfo-cardHeaderContent">
        <h2 className="t-memberInfo-cardTitle">{title}</h2>
        <div className="t-memberInfo-cardBadges">
          <span className="t-memberDetail-headerBadge">Üyelik Bilgilerim</span>
        </div>
      </div>
    </div>
  );

  renderEmailForm = () => (
    <form className="t-resetPassword-form t-controlContactInfo-form" onSubmit={this.submit} noValidate>
      {this.state.formAlert ? (
        <LoginPageAlert
          messages={this.state.formAlert.messages}
          type={this.state.formAlert.type}
          onDismiss={this.clearFormAlert}
        />
      ) : null}

      <div className="t-resetPassword-field">
        <label htmlFor="ePosta" className="t-resetPassword-label">
          Yeni mail adresiniz
        </label>
        <div
          className={`t-resetPassword-inputWrap t-submitDemand-inputWrap${
            this.state.emailHasError ? " t-error" : ""
          }`}
        >
          <div>
            <i className="t-icon-mail1" aria-hidden="true" />
          </div>
          <input
            type="email"
            placeholder="Yeni mail adresinizi giriniz"
            id="ePosta"
            name="ePosta"
            className="email"
            value={this.state.bilgi}
            required
            autoComplete="off"
            onChange={(e) => {
              this.setState({
                bilgi: e.target.value,
                emailHasError: false,
                formAlert: null,
              });
            }}
          />
          <div />
        </div>
      </div>

      <div className="t-resetPassword-actions">
        <button
          type="submit"
          id="submitMail"
          name="submitMail"
          className="t-memberInfo-btn t-memberInfo-btn--primary"
        >
          Değiştir
        </button>
      </div>

      {this.renderEmailSteps()}
    </form>
  );

  renderPhoneForm = () => (
    <form className="t-resetPassword-form t-controlContactInfo-form" onSubmit={this.submit} noValidate>
      {this.state.formAlert ? (
        <LoginPageAlert
          messages={this.state.formAlert.messages}
          type={this.state.formAlert.type}
          onDismiss={this.clearFormAlert}
        />
      ) : null}

      <div className="t-resetPassword-field">
        <label htmlFor="tel" className="t-resetPassword-label">
          Yeni cep telefon numaranız
        </label>
        <div className="t-controlContactInfo-phoneWrap">
          <PhoneInput
            country="tr"
            value={this.state.bilgi}
            placeholder="+90 500 000 00 00"
            containerClass="t-controlContactInfo-phoneInput"
            inputClass="t-controlContactInfo-phoneInputField"
            buttonClass="t-controlContactInfo-phoneButton"
            dropdownClass="t-controlContactInfo-phoneDropdown"
            inputProps={{
              id: "tel",
              name: "tel",
              required: true,
            }}
            countryCodeEditable={false}
            onChange={(value, data) => {
              this.setState({
                bilgi: value.replace(/\D/g, ""),
                countryPhoneCode: data?.dialCode || "90",
                formAlert: null,
              });
            }}
          />
        </div>
      </div>

      <div className="t-resetPassword-actions">
        <button
          type="submit"
          id="submitTel"
          name="submitTel"
          className="t-memberInfo-btn t-memberInfo-btn--primary"
        >
          Değiştir
        </button>
      </div>

      {this.renderContactSteps("Yeni Tel")}
    </form>
  );

  render() {
    const { match } = this.props;
    const { shouldAnimateCard, isProcessing } = this.state;

    const renderPageOverlay = isProcessing ? (
      <div className="t-eminevimLoadingOverlay">
        <EminevimLoading subtext="Bilgileriniz kontrol ediliyor, lütfen bekleyiniz." compact />
      </div>
    ) : null;

    return (
      <>
        {match?.params?.id === "Eposta" && (
          <div style={{ background: "#ffffff" }}>
            <div className="row" style={{ padding: "3%" }}>
              <div className="col-12">
                <div className="t-memberInfo-pageHeader">
                  <h1 className="t-memberInfo-pageTitle">Profilim</h1>
                  <p className="t-memberInfo-pageSubtitle">
                    Yeni e-posta adresinizi girin; doğrulama adımına geçmeden önce bilgilerinizi kontrol edin.
                  </p>
                </div>

                <article
                  className={`t-memberInfo-card t-memberDetail-header--green${
                    shouldAnimateCard ? " t-memberInfo-card--enter" : ""
                  }`}
                >
                  {this.renderContactHeader("t-icon-mail1", "Mail Adresimi Değiştir")}

                  {this.renderEmailForm()}
                </article>
              </div>
            </div>
            <div className="row" style={{ height: 30 }} />
            {renderPageOverlay}
          </div>
        )}

        {match?.params?.id === "Gsm" && (
          <div style={{ background: "#ffffff" }}>
            <div className="row" style={{ padding: "3%" }}>
              <div className="col-12">
                <div className="t-memberInfo-pageHeader">
                  <h1 className="t-memberInfo-pageTitle">Profilim</h1>
                  <p className="t-memberInfo-pageSubtitle">
                    Yeni cep telefon numaranızı girin; doğrulama adımına geçmeden önce bilgilerinizi kontrol edin.
                  </p>
                </div>

                <article
                  className={`t-memberInfo-card t-memberDetail-header--green${
                    shouldAnimateCard ? " t-memberInfo-card--enter" : ""
                  }`}
                >
                  {this.renderContactHeader("t-icon-phone", "Telefon Numaramı Değiştir")}

                  {this.renderPhoneForm()}
                </article>
              </div>
            </div>
            <div className="row" style={{ height: 30 }} />
            {renderPageOverlay}
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  member: selectMemberInfo(state),
});

const mapDispatchToProps = (dispatch) => ({
  controlContactInfo: (bilgi, iletisimTur, countryPhoneCode) =>
    dispatch(controlContactInfos(bilgi, iletisimTur, countryPhoneCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ControlContactInfo);
